// src/app/modules/.../redux/sagas/workflowValidationSaga.js

import { put, call } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    getWorkflowLevelsSuccess,
    getWorkflowLevelsFail,
    saveWorkflowLevelsSuccess,
    saveWorkflowLevelsFail,
    setWorkflowValidationLoading
} from "../actions/workflowValidationActions";

import { API_BASE_URL, getRequest, postRequest } from "../../../api";

// ✅ GET: /paramAdm/niveaux
export function* getWorkflowLevelsSaga(action) {
    const url = `${API_BASE_URL}/api/paramadm/niveaux`;
    const token = sessionStorage.getItem('token');

    yield put(setWorkflowValidationLoading(true));

    try {
        console.group('🔵 GET_WORKFLOW_LEVELS_REQUEST');
        console.log('🌐 URL:', url);
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url,token });

        console.group('✅ GET_WORKFLOW_LEVELS_SUCCESS');
        console.log('📥 Réponse API:', resp.data);
        console.groupEnd();

        yield put(getWorkflowLevelsSuccess(resp.data || {}));
        yield put(setWorkflowValidationLoading(false));

    } catch (error) {
        console.group('❌ GET_WORKFLOW_LEVELS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getWorkflowLevelsFail(error.message));
        yield put(setWorkflowValidationLoading(false));

        // optionnel (si tu veux pas de popup, supprime ce bloc)
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors du chargement des niveaux",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

// ✅ POST: /paramAdm/niveau
export function* saveWorkflowLevelsSaga(action) {
    const url = `${API_BASE_URL}/api/paramadm/save`;
    const levelsMap = action.payload || {};
    const token = sessionStorage.getItem('token');

    yield put(setWorkflowValidationLoading(true));

    try {
        console.group('🔵 SAVE_WORKFLOW_LEVELS_REQUEST');
        console.log('🌐 URL:', url);
        console.log('📊 Levels Map:', levelsMap);
        console.groupEnd();

        const data = Object.entries(levelsMap).map(([requestId, level]) => ({
            requestId,
            level,
            updatedAt: new Date().toISOString()
        }));

        const resp = yield call(postRequest, { url,token, data });

        console.group('✅ SAVE_WORKFLOW_LEVELS_SUCCESS');
        console.log('📥 Réponse API:', resp?.data);
        console.groupEnd();

        yield put(saveWorkflowLevelsSuccess());
        yield put(setWorkflowValidationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Configuration enregistrée avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.group('❌ SAVE_WORKFLOW_LEVELS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(saveWorkflowLevelsFail(error.message));
        yield put(setWorkflowValidationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de l'enregistrement",
            timer: 2000,
            showConfirmButton: false
        });
    }
}
